export default function genererCritereRecherche() {
  return {
    auto: '',
    produitAchatIds: [],
    formatAfficheIds: [],
    natureSupportAfficheIds: [],
    typeMaterielIds: [],
    tiersDestinataireIds: [],
    lieuLivraisonPrestationIds: [],
    dateLivraison: {
      dateDebut: null,
      dateFin: null,
    },
    commande: null,
    codesCommandeAchat: [],
  };
}
